import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { ExpensesPage } from '@/features/expenses/pages/ExpensesPage'

const searchSchema = z.object({
  tab: z.enum(['expenses', 'recurring', 'budgets']).catch('expenses'),
})

export const Route = createFileRoute('/_app/expenses/')({
  validateSearch: searchSchema,
  component: ExpensesPage,
})
